(function (Drupal) {
  'use strict';

  Drupal.behaviors.kafMobileRecipeH1 = {
    attach: function (context, settings) {
      const header = context.querySelector('#quickview--label > h1');
      if (!header) {
        return;
      }
      const fauxHeader = context.querySelector('#hero--label > .backup-label');
      const quickviewParent = context.querySelector('#quickview--label');
      const marqueeParent = context.querySelector('#hero--label');
      let displayMobile = true;

      const moveH1 = function () {
        let isMobile = !window.matchMedia('(min-width: 960px)').matches;
        if (isMobile && !displayMobile) {
          marqueeParent.appendChild(fauxHeader);
          quickviewParent.appendChild(header);
          displayMobile = true;
        }
        else if (!isMobile && displayMobile) {
          quickviewParent.appendChild(fauxHeader);
          marqueeParent.appendChild(header);
          displayMobile = false;
        }
      };
      // Move H1 out of header if display is at desktop width.
      moveH1();
      // Check if H1 needs to be moved on window resize.
      window.addEventListener('resize', Drupal.debounce(moveH1, 250, false));
    },
  };
})(Drupal);
